import { forwardRef } from 'react';

import { noop } from '@perpay-web/utils/noop';

import { CustomInputWithErrors } from './CustomInput';

const FormikCustomInput = forwardRef(
    (
        {
            field: { name, value, onChange: formikOnChange, ...fieldRest },
            form: { touched, errors } = { touched: {}, errors: {} },
            label,
            floatingLabel = true,
            type = 'text',
            hidden = false,
            disabled = false,
            onChange = noop,
            ...rest
        },
        ref,
    ) => {
        const combinedOnChange = (e) => {
            formikOnChange(e);
            onChange(e);
        };

        const fieldTouched = touched[name];
        const fieldErrors = errors[name];

        return (
            <CustomInputWithErrors
                ref={ref}
                name={name}
                value={value}
                label={label}
                floatingLabel={floatingLabel}
                type={type}
                hidden={hidden}
                disabled={disabled}
                errors={fieldErrors}
                touched={fieldTouched}
                onChange={combinedOnChange}
                {...rest}
                {...fieldRest}
            />
        );
    },
);

FormikCustomInput.displayName = 'FormikCustomInput';

export default FormikCustomInput;
